var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"gt__btn",class:_vm.styleClass},_vm.$listeners),[_c('span',[_vm._t("default")],2),(_vm.isLoading)?_c('GtLoading',{attrs:{"size":"0.75rem","fill":"#ffffff"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }